const courseTypes = {
  Basic: { id: 1, name: "basic" },
  Advanced: { id: 2, name: "advanced" }
};

export { courseTypes };
